let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bS0aO"), load("hGXAt"), load("1or3R")]).then(() => parcelRequire('3Subp'));